var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootballFieldOpposite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "870px",
    height: "599px",
    viewBox: "0 0 870 599",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.849999964
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Opponents-Formation-(Desktop)-",
    transform: "translate(-265.000000, -301.000000)",
    fill: "#00B259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-87",
    transform: "translate(265.000000, 301.467312)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "867.766924 589.138974 729.485554 0 157.659388 0 146.885591 40.8605432 0 598.695324 260.592543 598.695324 607.724713 598.695324 870 598.695324"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballFieldOpposite);
export default __webpack_public_path__ + "static/media/football-field-opposite.2e6145ced879a38c9c11c5bcfd380c98.svg";
export { ForwardRef as ReactComponent };